export default {
  items: [
    {
      title: true,
      name: 'Clientes',
      class: ''             // optional class names space delimited list for title item ex: "text-center"
    },
    {
      name: 'Pesquisar',
      url: '/cliente/pesquisa',
      icon: 'fa fa-search fa-lg',
    },
    {
      name: 'Cadastrar',
      url: '/cliente/cadastro',
      icon: 'fa fa-user-plus fa-lg',
    },
   
  ],
};
